import HeaderSignIn from "../../components/headers/HeaderSignIn";
import UserDetailInfoFormStep from "./1_UserDetailInfoFormStep";
import PhoneNumFormStep from "./2_PhoneNumFormStep";
import PhoneNumConfirmStep from "./3_PhoneNumConfirmStep";
import SignUpInfoFormStep from "./4_SignUpInfoFormStep";
import EmailConfirmStep from "./5_EmailConfirmStep";
import { Stepper, Step, StepLabel, Box, Container } from "@mui/material";
import React, { useState } from "react";

const stepNames = [
  "ユーザ情報入力",
  "電話番号入力",
  "SMS認証",
  "サインアップ情報入力",
  "Email認証",
];

const SignUpStepperPage: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [requestId, setRequestId] = useState<string | null>(null);

  const handleNextStep: () => void = (): void => {
    setActiveStep((prevActiveStep: number): number => prevActiveStep + 1);
  };
  const handlePrevStep: () => void = (): void => {
    setActiveStep((prevActiveStep: number): number =>
      prevActiveStep > 0 ? prevActiveStep - 1 : prevActiveStep
    );
  };
  const handleRequestId = (id: string): void => {
    setRequestId(id);
    handleNextStep();
  };

  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <UserDetailInfoFormStep onNext={handleNextStep} />;
      case 1:
        return <PhoneNumFormStep onNext={handleRequestId} />;
      case 2:
        return (
          requestId && (
            <PhoneNumConfirmStep
              onPrev={handlePrevStep}
              onNext={handleNextStep}
              requestId={requestId}
            />
          )
        );
      case 3:
        return <SignUpInfoFormStep onNext={handleNextStep} />;
      case 4:
        return <EmailConfirmStep onPrev={handlePrevStep} />;
      default:
        return null;
    }
  };

  return (
    <>
      <HeaderSignIn />
      <Container maxWidth="sm">
        <Box mt={5}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {stepNames.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box mt={4}>{renderStepContent(activeStep)}</Box>
        </Box>
      </Container>
    </>
  );
};

export default SignUpStepperPage;
